import React, { useState } from 'react'

import 'moment/locale/pt-br'

import { Form, Col, InputNumber } from 'antd'

const InputTable = (props) => {
  const { customFormId, field, name, values, value } = props

  const obj = {}
  const lines = []

  if (value && value.customFields && value.customFields[name]) {
    try {
      const fieldItems = JSON.parse(value.customFields[name])
      console.log(fieldItems)
      fieldItems.forEach((item) => {
        obj[item.id] = item
        lines.push(renderLine(item.id, item.text, onChangeItemOrder, item.order))
      })
    } catch (error) {
      console.log(error)
    }
  }

  if (lines.length === 0) {
    values.forEach((item) => {
      obj[item.value] = { id: item.value, text: item.description, order: 0 }
      lines.push(renderLine(item.value, item.description, onChangeItemOrder, 0))
    })
  }

  const [helper, setHelper] = useState(obj)

  function onChangeItemOrder(id, order) {
    console.log(`onChangeItemOrder ${id} ${order}`)
    helper[id].order = order
    setHelper(helper)
    const val = JSON.stringify(Object.values(helper))
    console.log(val)
    props.setFieldValue(name, val, customFormId)
  }

  return (
    <Col xs={24} sm={24}>
      {field}
      <Form.Item label="">
        <table>
          <tbody>{lines}</tbody>
        </table>
      </Form.Item>
    </Col>
  )
}

function renderLine(id, description, onChangeItemOrder, savedValue = 0) {
  return () => {
    const [value, setValue] = useState(savedValue)
    return (
      <tr key={`key_${id}`}>
        <td>{description}</td>
        <td>
          <InputNumber
            value={value}
            size="small"
            min={0}
            max={99}
            defaultValue={0}
            onChange={(value) => {
              setValue(value)
              onChangeItemOrder(id, value)
            }}
          />
        </td>
      </tr>
    )
  }
}

export default InputTable
